import React from 'react';
import { Timeline, Typography, Space, Spin, Tag, Collapse } from 'antd';
import { HistoryOutlined, SwapOutlined, WarningOutlined } from '@ant-design/icons';
import { useGetPaymentMethodChangesQuery } from '../../../services/ordersApi';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';
import { useRestaurantTimeZone } from '../../../hooks/useTimeZone';

dayjs.extend(relativeTime);
dayjs.locale('es');

const { Text } = Typography;

interface PaymentMethodChangesHistoryProps {
  orderId: string;
}

const PaymentMethodChangesHistory: React.FC<PaymentMethodChangesHistoryProps> = ({ orderId }) => {
  const { data: changes = [], isLoading } = useGetPaymentMethodChangesQuery(orderId);
  const { formatInTimeZone } = useRestaurantTimeZone();

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>
        <Spin />
      </div>
    );
  }

  if (changes.length === 0) {
    return null; // No mostrar nada si no hay cambios
  }

  return (
    <Collapse
      ghost
      items={[
        {
          key: '1',
          label: (
            <Space>
              <WarningOutlined style={{ color: '#faad14' }} />
              <Text strong style={{ color: '#faad14' }}>
                Historial de Cambios de Método de Pago ({changes.length})
              </Text>
            </Space>
          ),
          children: (
            <Timeline
              mode="left"
              items={changes.map((change) => ({
                color: 'orange',
                dot: <SwapOutlined />,
                children: (
                  <div>
                    <div style={{ marginBottom: 8 }}>
                      <Space direction="vertical" size="small">
                        <Space>
                          <Tag color="red">{change.oldPaymentMethodName}</Tag>
                          <SwapOutlined />
                          <Tag color="green">{change.newPaymentMethodName}</Tag>
                        </Space>
                        <div>
                          <Text strong>Razón: </Text>
                          <Text>{change.reason}</Text>
                        </div>
                        {change.notes && (
                          <div>
                            <Text strong>Notas: </Text>
                            <Text type="secondary">{change.notes}</Text>
                          </div>
                        )}
                        <div>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            <HistoryOutlined /> {change.changedByUserName} -{' '}
                            {formatInTimeZone(change.changedAt, 'DD/MM/YYYY HH:mm')} (
                            {dayjs(change.changedAt).fromNow()})
                          </Text>
                        </div>
                      </Space>
                    </div>
                  </div>
                ),
              }))}
            />
          ),
        },
      ]}
    />
  );
};

export default PaymentMethodChangesHistory;
